import React from 'react';
import DiagramCanvas from '../diagram/DiagramCanvas';
import { emptyDiagram, parseDiagram } from '../diagram/types';

/** A gyakorlat rajza kicsiben; rajz nélkül egy üres, halvány pálya jelzi a helyét. */
const DrillThumbnail: React.FC<{ diagram?: string | null; title: string; className?: string }> = ({
  diagram,
  title,
  className = '',
}) => {
  const parsed = parseDiagram(diagram);
  return (
    <div className={`relative overflow-hidden rounded-md ${className}`}>
      <DiagramCanvas diagram={parsed ?? emptyDiagram()} title={title} className={`block h-auto w-full ${parsed ? '' : 'opacity-40'}`} />
      {!parsed && (
        <span className="absolute inset-0 flex items-center justify-center">
          <span className="rounded-full bg-gray-900/60 px-2.5 py-0.5 text-xs font-medium text-white">Nincs rajz</span>
        </span>
      )}
    </div>
  );
};

export default DrillThumbnail;
